import script from "./CvContentSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./CvContentSwitcher.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__